export default "__VITE_ASSET__C3eyK_$N__"